import axios from 'axios';
import { apiUrl } from '../config/api';

// Thin helpers to centralize UI audit calls and avoid leaking modal contents.
const withAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` } });

export async function auditPageView(page) {
  if (!page) return;
  try {
    await axios.post(apiUrl('/api/audits/page-view'), { page }, withAuth());
  } catch (_) {
    // Never block UI
  }
}

export async function auditModalView(modalName) {
  if (!modalName) return;
  try {
    await axios.post(apiUrl('/api/audits/event'), {
      action: `Modal Viewed: ${modalName}`,
      entityType: 'Modal',
      details: { modal: modalName }
    }, withAuth());
  } catch (_) {}
}

export async function auditUiAction(action, details) {
  if (!action) return;
  try {
    await axios.post(apiUrl('/api/audits/event'), {
      action,
      entityType: 'UI',
      details: details && typeof details === 'object' ? details : undefined
    }, withAuth());
  } catch (_) {}
}
